<template>
  <div class="">
    <div class="row">
      <div class="col-md-12">
        <h3 class="text-center"> MAPPING QUALITY CONTROL </h3>
      </div>

      <div class="col-md-12"></div>
      <div v-if="Object.keys(qc_picard_hs).length !== 0" class="col-md-12 mr-auto ml-auto">
        <card>
          <el-table
            :data="[qc_picard_hs]"
            border
            :header-cell-style="tableHeaderStyle"
            style="width: 100%">
            <el-table-column
              prop="genome_size"
              label="Genome size"
              min-width="160"
              align="center"
              >
              <template slot-scope="scope">
                  {{ scope.row.genome_size.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="total_reads"
              label="Total reads"
              min-width="160"
              align="center"
              >
              <template slot-scope="scope">
                  {{ scope.row.total_reads.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="pf_unique_reads"
              label="PF uniq reads"
              min-width="160"
              align="center"
              >
              <template slot-scope="scope">
                  {{ scope.row.pf_unique_reads.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="pct_pf_uq_reads"
              label="% PF uniq reads"
              min-width="160"
              align="center"
              >
              <template slot-scope="scope">
                  {{ scope.row.pct_pf_uq_reads.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="pf_uq_reads_aligned"
              label="PF uniq reads aligned"
              min-width="200"
              align="center"
              >
              <template slot-scope="scope">
                  {{ scope.row.pf_uq_reads_aligned.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="pct_pf_uq_reads_aligned"
              label="% PF uniq reads aligned"
              min-width="200"
              align="center"
              >
              <template slot-scope="scope">
                  {{ scope.row.pct_pf_uq_reads_aligned.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>
          </el-table>
        </card>
      </div>

      <div v-if="Object.keys(qc_picard_amp).length !== 0" class="col-md-12 mr-auto ml-auto">
        <card>
          <el-table
            :data="[qc_picard_amp]"
            border
            :header-cell-style="tableHeaderStyle"
            style="width: 100%">
            <el-table-column
              prop="genome_size"
              label="Genome size"
              min-width="160"
              align="center"
              >
              <template slot-scope="scope">
                  {{ scope.row.genome_size.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="target_territory"
              label="Target territory"
              min-width="160"
              align="center"
              >
              <template slot-scope="scope">
                  {{ scope.row.target_territory.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="total_reads"
              label="Total reads"
              min-width="160"
              align="center"
              >
              <template slot-scope="scope">
                  {{ scope.row.total_reads.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="pf_uq_reads_aligned"
              label="PF uniq reads aligned"
              min-width="200"
              align="center"
              >
              <template slot-scope="scope">
                  {{ scope.row.pf_uq_reads_aligned.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="pct_pf_uq_reads_aligned"
              label="% PF uniq reads aligned"
              min-width="200"
              align="center"
              >
              <template slot-scope="scope">
                  {{ scope.row.pct_pf_uq_reads_aligned.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>
          </el-table>
        </card>
      </div>

      <div class="col-md-12"></div>
      <el-divider></el-divider>
    </div>

    <div v-if="Object.keys(qc_picard_hs).length !== 0" class="row">
      <div class="col-md-12">
        <h4 class="text-center"></h4>
      </div>

      <div class="col-md-12 mr-auto ml-auto">
        <card>
          <el-table
            :data="[qc_picard_hs]"
            border
            :header-cell-style="tableHeaderStyle"
            style="width: 100%"
            align="center"
          >
            <el-table-column
              prop="median_target_coverage"
              min-width="140"
              align="center"
            >
              <template #header>
                <el-tooltip
                  placement="top"
                  effect="light"
                  :open-delay="500"
                  popper-class="custom-tooltip"
                >
                  <div slot="content">
                    <b>Median coverage</b><br>
                    Median sequencing depth across the target regions.<br><br>
                    In simple terms: the typical coverage value for the regions that should be evaluated.<br><br>
                    <b>Expected values:</b> depends on the assay and required sensitivity.<br>
                    Higher is generally better. For germline panels, values above 50–100 are often acceptable; for low-frequency somatic variant detection, substantially higher coverage is usually needed.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">Median coverage</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                {{ scope.row.median_target_coverage.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="mean_target_coverage"
              min-width="140"
              align="center"
            >
              <template #header>
                <el-tooltip
                  placement="top"
                  effect="light"
                  :open-delay="500"
                  popper-class="custom-tooltip"
                >
                  <div slot="content">
                    <b>Mean coverage</b><br>
                    Average sequencing depth across the target regions.<br><br>
                    In simple terms: the average amount of sequencing data covering the tested regions.<br><br>
                    <b>Expected values:</b> higher is generally better, but it should be interpreted together with median coverage, minimum coverage, and uniformity.<br>
                    If mean coverage is much higher than median coverage, coverage may be uneven.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">Mean coverage</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                {{ scope.row.mean_target_coverage.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="max_target_coverage"
              min-width="140"
              align="center"
            >
              <template #header>
                <el-tooltip
                  placement="top"
                  effect="light"
                  :open-delay="500"
                  popper-class="custom-tooltip"
                >
                  <div slot="content">
                    <b>Maximum coverage</b><br>
                    Highest observed coverage in the target regions.<br><br>
                    In simple terms: the most strongly covered target position or region.<br><br>
                    <b>Expected values:</b> high values are not a problem by themselves.<br>
                    Very high maximum coverage should be interpreted together with uniformity, because it may indicate uneven coverage.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">Max coverage</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                {{ scope.row.max_target_coverage.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="min_target_coverage"
              min-width="140"
              align="center"
            >
              <template #header>
                <el-tooltip
                  placement="top"
                  effect="light"
                  :open-delay="500"
                  popper-class="custom-tooltip"
                >
                  <div slot="content">
                    <b>Minimum coverage</b><br>
                    Lowest observed coverage in the target regions.<br><br>
                    In simple terms: the weakest covered part of the tested region.<br><br>
                    <b>Expected values:</b> higher is better.<br>
                    A value of 0 means that at least one target position or region had no coverage and should be reviewed, especially if clinically important.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">Min coverage</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                {{ scope.row.min_target_coverage.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="fold_80_base_penalty"
              min-width="140"
              align="center"
            >
              <template #header>
                <el-tooltip
                  placement="top"
                  effect="light"
                  :open-delay="500"
                  popper-class="custom-tooltip"
                >
                  <div slot="content">
                    <b>Uniformity</b><br>
                    Picard Fold 80 Base Penalty. It estimates how much extra sequencing would be needed so that 80% of target bases reach the mean coverage.<br><br>
                    In simple terms: how evenly the target regions are covered.<br><br>
                    <b>Expected values:</b> lower is better.<br>
                    Around 1 is excellent. Values below 2 are usually acceptable for many targeted assays. Higher values indicate less uniform coverage.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">Uniformity</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                {{ scope.row.fold_80_base_penalty.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="pct_exc_dupe"
              min-width="180"
              align="center"
            >
              <template #header>
                <el-tooltip
                  placement="top"
                  effect="light"
                  :open-delay="500"
                  popper-class="custom-tooltip"
                >
                  <div slot="content">
                    <b>PCR duplicates</b><br>
                    Percentage of bases excluded because they came from duplicate reads.<br><br>
                    In simple terms: how much sequencing information was lost due to repeated copies of the same original molecule.<br><br>
                    <b>Expected values:</b> lower is better.<br>
                    Values below 10–20 are usually good. Higher values may suggest low library complexity, over-amplification, or limited input DNA.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">% PCR Duplicates</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                {{ scope.row.pct_exc_dupe.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="zero_cvg_targets_pct"
              min-width="180"
              align="center"
            >
              <template #header>
                <el-tooltip
                  placement="top"
                  effect="light"
                  :open-delay="500"
                  popper-class="custom-tooltip"
                >
                  <div slot="content">
                    <b>Zero target coverage</b><br>
                    Percentage of target regions with no usable coverage.<br><br>
                    In simple terms: parts of the intended test region that were not sequenced at all.<br><br>
                    <b>Expected values:</b> ideally 0.<br>
                    Any non-zero value should be reviewed, especially for genes or regions relevant to the clinical indication.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">% Zero target coverage</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                {{ scope.row.zero_cvg_targets_pct.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>
          </el-table>
        </card>
      </div>

      <el-divider></el-divider>
    </div>

    <div v-if="Object.keys(qc_picard_hs).length !== 0" class="row">
      <div class="col-md-12">
        <h4 class="text-center"></h4>
      </div>

      <div class="col-md-12 mr-auto ml-auto">
        <card>
          <el-table
            :data="[qc_picard_hs]"
            border
            :header-cell-style="tableHeaderStyle"
            style="width: 100%"
          >
            <el-table-column
              prop="pct_selected_bases"
              min-width="130"
              align="center"
            >
              <template #header>
                <el-tooltip
                  placement="top"
                  effect="light"
                  :open-delay="500"
                  popper-class="custom-tooltip"
                >
                  <div slot="content">
                    <b>On-target bases</b><br>
                    Percentage of aligned bases that fall on selected target or bait-related regions.<br><br>
                    In simple terms: how much of the sequencing data landed where the test was designed to look.<br><br>
                    <b>Expected values:</b> higher is better.<br>
                    Values above 70–80 are usually good for many capture assays. Lower values may indicate inefficient enrichment or too much off-target sequencing.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">% On-target</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                {{ scope.row.pct_selected_bases.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="pct_off_bait"
              min-width="130"
              align="center"
            >
              <template #header>
                <el-tooltip
                  placement="top"
                  effect="light"
                  :open-delay="500"
                  popper-class="custom-tooltip"
                >
                  <div slot="content">
                    <b>Off-target bases</b><br>
                    Percentage of bases that mapped outside bait regions.<br><br>
                    In simple terms: sequencing data spent outside the intended capture regions.<br><br>
                    <b>Expected values:</b> lower is better.<br>
                    Values below 10–20 are often good. Higher values may suggest less efficient capture or more background sequencing.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">% Off-target</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                {{ scope.row.pct_off_bait.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="pct_exc_adapter"
              min-width="130"
              align="center"
            >
              <template #header>
                <el-tooltip
                  placement="top"
                  effect="light"
                  :open-delay="500"
                  popper-class="custom-tooltip"
                >
                  <div slot="content">
                    <b>Adapter exclusion</b><br>
                    Percentage of bases excluded because adapter sequence was detected.<br><br>
                    In simple terms: how much data was affected by sequencing into adapters, often due to short DNA fragments or library preparation issues.<br><br>
                    <b>Expected values:</b> ideally close to 0.<br>
                    Higher values may suggest short inserts or adapter contamination.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">% Adapters</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                {{ scope.row.pct_exc_adapter.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="het_snp_sensitivity"
              min-width="160"
              align="center"
            >
              <template #header>
                <el-tooltip
                  placement="top"
                  effect="light"
                  :open-delay="500"
                  popper-class="custom-tooltip"
                >
                  <div slot="content">
                    <b>HET SNP sensitivity</b><br>
                    Picard estimate of the probability of detecting heterozygous SNPs based on the observed coverage distribution.<br><br>
                    In simple terms: an overall estimate of whether the coverage is sufficient to reliably detect heterozygous variants.<br><br>
                    <b>Expected values:</b> closer to 1 is better.<br>
                    Values around 1 are excellent. Lower values suggest insufficient or uneven coverage.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">HET SNP sensitivity</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                {{ scope.row.het_snp_sensitivity.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="het_snp_q"
              min-width="160"
              align="center"
            >
              <template #header>
                <el-tooltip
                  placement="top"
                  effect="light"
                  :open-delay="500"
                  popper-class="custom-tooltip"
                >
                  <div slot="content">
                    <b>HET SNP quality</b><br>
                    Phred-scaled quality score derived from the estimated heterozygous SNP sensitivity.<br><br>
                    In simple terms: a quality score summarizing confidence in heterozygous variant detection.<br><br>
                    <b>Expected values:</b> higher is better.<br>
                    Values above 20–30 are generally reassuring; very low values indicate reduced confidence.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">HET SNP quality</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                {{ scope.row.het_snp_q.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="at_dropout"
              min-width="170"
              align="center"
            >
              <template #header>
                <el-tooltip
                  placement="top"
                  effect="light"
                  :open-delay="500"
                  popper-class="custom-tooltip"
                >
                  <div slot="content">
                    <b>AT dropout</b><br>
                    Measure of reduced coverage in AT-rich regions compared with the expected representation.<br><br>
                    In simple terms: whether AT-rich regions are under-covered.<br><br>
                    <b>Expected values:</b> lower is better.<br>
                    Values close to 0 are ideal. Increased values may indicate sequence-context bias affecting AT-rich targets.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">AT dropout</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                {{ scope.row.at_dropout.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="gc_dropout"
              width="170"
              align="center"
            >
              <template #header>
                <el-tooltip
                  placement="top"
                  effect="light"
                  :open-delay="500"
                  popper-class="custom-tooltip"
                >
                  <div slot="content">
                    <b>GC dropout</b><br>
                    Measure of reduced coverage in GC-rich regions compared with the expected representation.<br><br>
                    In simple terms: whether GC-rich regions are under-covered.<br><br>
                    <b>Expected values:</b> lower is better.<br>
                    Values close to 0 are ideal. Increased values may indicate GC-related capture or amplification bias.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">GC dropout</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                {{ scope.row.gc_dropout.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>
          </el-table>
        </card>
      </div>

      <el-divider></el-divider>
    </div>

    <div v-if="Object.keys(qc_picard_amp).length !== 0" class="row">
      <div class="col-md-12">
        <h4 class="text-center"></h4>
      </div>

      <div class="col-md-12 mr-auto ml-auto">
        <card>
          <el-table
            :data="[qc_picard_amp]"
            border
            :header-cell-style="tableHeaderStyle"
            style="width: 100%">
            <el-table-column
              prop="median_target_coverage"
              label="Median coverage"
              min-width="130"
              align="center"
              >
              <template slot-scope="scope">
                  {{ scope.row.median_target_coverage.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="mean_target_coverage"
              label="Mean coverage"
              min-width="130"
              align="center"
              >
              <template slot-scope="scope">
                  {{ scope.row.mean_target_coverage.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="max_target_coverage"
              label="Max coverage"
              min-width="130"
              align="center"
              >
              <template slot-scope="scope">
                  {{ scope.row.max_target_coverage.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="min_target_coverage"
              label="Min coverage"
              min-width="160"
              align="center"
              >
              <template slot-scope="scope">
                  {{ scope.row.min_target_coverage.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="zero_cvg_targets_pct"
              label="Zero coverage"
              min-width="160"
              align="center"
              >
              <template slot-scope="scope">
                  {{ scope.row.zero_cvg_targets_pct.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="at_dropout"
              label="AT dropout"
              min-width="170"
              align="center"
              >
              <template slot-scope="scope">
                  {{ scope.row.at_dropout.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="gc_dropout"
              label="GC dropout"
              min-width="170"
              align="center"
              >
              <template slot-scope="scope">
                  {{ scope.row.gc_dropout.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>
          </el-table>
        </card>
      </div>

      <el-divider></el-divider>
    </div>

    <div v-if="qc_picard_amp_target.length !== 0" class="row">
      <div class="col-md-12">
        <h4 class="text-center"> Hotspot coverage </h4>
      </div>
      <div class="col-md-12 mr-auto ml-auto">
        <card>
          <el-table
            :data="qc_picard_amp_target"
            border
            :max-height="700"
            :header-cell-style="tableHeaderStyle"
            style="width: 100%"
            show-summary
            :summary-method="qc_picard_amp_target_summary"
            >
            <el-table-column
              prop="name"
              label="Name"
              min-width="280"
              align="left"
              >
            </el-table-column>

            <el-table-column
              prop="min_coverage"
              label="Min coverage"
              min-width="120"
              align="center"
              >
              <template slot-scope="scope">
                  {{ scope.row.min_coverage.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="mean_coverage"
              label="Mean coverage"
              min-width="120"
              align="center"
              >
              <template slot-scope="scope">
                  {{ scope.row.mean_coverage.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="max_coverage"
              label="Max coverage"
              min-width="110"
              align="center"
              >
              <template slot-scope="scope">
                  {{ scope.row.max_coverage.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="pct_0x"
              label="% 0x"
              min-width="80"
              align="center"
              >
              <template slot-scope="scope">
                  {{ scope.row.pct_0x.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="read_count"
              label="Reads count"
              min-width="100"
              align="center"
              >
              <template slot-scope="scope">
                  {{ scope.row.read_count.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="chrom"
              label="Chr"
              min-width="90"
              align="center"
              >
            </el-table-column>

            <el-table-column
              prop="c_start"
              label="Start"
              min-width="120"
              align="center"
              >
              <template slot-scope="scope">
                  {{ scope.row.c_start.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="c_end"
              label="Stop"
              min-width="120"
              align="center"
              >
              <template slot-scope="scope">
                  {{ scope.row.c_end.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="length"
              label="Length"
              min-width="80"
              align="center"
              >
              <template slot-scope="scope">
                  {{ scope.row.length.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="gc"
              label="GC"
              min-width="100"
              align="center"
              >
              <template slot-scope="scope">
                  {{ scope.row.gc.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>
          </el-table>
        </card>
      </div>
    </div>

    <div v-if="chart_bar_a.length !== 0" class="col-md-12 mr-auto ml-auto">
      <div class="col-md-12">
        <h4 class="text-center">Target coverage</h4>
      </div>
      <div class="card">
        <div class="card-body mr-auto ml-auto">
          <slot name="title-content">
            <div class="row">
              <div class="col-sm-7">
                <div class="numbers pull-left">
                  <slot name="title"></slot>
                </div>
              </div>
              <div class="col-sm-5">
                <div class="pull-right">
                  <slot name="title-label"></slot>
                </div>
              </div>
            </div>
          </slot>
          <slot name="subtitle">Bases in target region [%]</slot>
          <la-cartesian narrow :bound="[0,100]" :data="chart_bar_a" :width="800">
            <la-bar prop="value"></la-bar>
            <la-x-axis :fontSize="13" prop="name"></la-x-axis>
            <la-y-axis :fontSize="13" :nbTicks="5" gridline prop="XXXXXX" :format="v => parseInt(v)"></la-y-axis>
            <la-tooltip></la-tooltip>

          </la-cartesian>
          <div class="col-sm-12">
            <div class="pull-right">
              <slot name="title-label">Coverage</slot>
            </div>
          </div>

        </div>

        <div class="card-footer">
          <slot name="footer">
            <hr>
            <div class="row">
              <div class="col-sm-7">
                <div class="footer-title">
                  <slot name="footer-title"></slot>
                </div>
              </div>
              <div class="col-sm-5">
                <div class="pull-right">
                  <slot name="footer-right"></slot>
                </div>
              </div>
            </div>
          </slot>
        </div>
      </div>
    </div>


    <div v-if="Object.keys(qc_picard_rna).length !== 0" class="row">
      <div class="col-md-12">
        <div class="qc-section-title text-center">RNA-seq read summary</div>
      </div>

      <div class="col-md-12 mr-auto ml-auto">
        <card>
          <el-table
            :data="[qc_picard_rna]"
            border
            :header-cell-style="tableHeaderStyle"
            style="width: 100%"
          >
            <el-table-column
              prop="pf_bases"
              min-width="150"
              align="center"
            >
              <template #header>
                <el-tooltip
                  placement="top"
                  effect="light"
                  :open-delay="500"
                  popper-class="custom-tooltip"
                >
                  <div slot="content">
                    <b>PF bases</b><br>
                    Total number of bases from reads that passed the sequencer quality filter.<br><br>
                    In simple terms: the total amount of sequencing data available before focusing only on mapped reads.<br><br>
                    <b>Expected values:</b> higher values usually mean more input data. Interpretation depends on the assay size, sequencing depth, and sample type.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">PF bases</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                {{ scope.row.pf_bases.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="pf_aligned_bases"
              min-width="160"
              align="center"
            >
              <template #header>
                <el-tooltip
                  placement="top"
                  effect="light"
                  :open-delay="500"
                  popper-class="custom-tooltip"
                >
                  <div slot="content">
                    <b>Aligned bases</b><br>
                    Number of PF bases that were successfully aligned to the reference.<br><br>
                    In simple terms: the part of the sequencing data that could be mapped and used for RNA analysis.<br><br>
                    <b>Expected values:</b> should be close to PF bases in good-quality samples. A large drop may indicate poor mapping, contamination, or technical issues.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">Aligned bases</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                {{ scope.row.pf_aligned_bases.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="ribosomal_bases"
              min-width="160"
              align="center"
            >
              <template #header>
                <el-tooltip
                  placement="top"
                  effect="light"
                  :open-delay="500"
                  popper-class="custom-tooltip"
                >
                  <div slot="content">
                    <b>Ribosomal bases</b><br>
                    Number of bases aligned to ribosomal RNA sequences.<br><br>
                    In simple terms: sequencing signal spent on ribosomal RNA, which is usually not the main target of clinical RNA analysis.<br><br>
                    <b>Expected values:</b> lower is better. High values may suggest inefficient ribosomal RNA depletion or reduced useful RNA signal.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">Ribosomal bases</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                {{ scope.row.ribosomal_bases.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="ignored_reads"
              min-width="150"
              align="center"
            >
              <template #header>
                <el-tooltip
                  placement="top"
                  effect="light"
                  :open-delay="500"
                  popper-class="custom-tooltip"
                >
                  <div slot="content">
                    <b>Ignored reads</b><br>
                    Reads mapped to sequences intentionally excluded from RNA metric calculation.<br><br>
                    In simple terms: reads that Picard recognized but did not include in the main RNA metrics because they belong to ignored reference sequences.<br><br>
                    <b>Expected values:</b> ideally low or zero. Interpretation depends on the pipeline configuration.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">Ignored reads</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                {{ scope.row.ignored_reads.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="unexplained_reads"
              min-width="160"
              align="center"
            >
              <template #header>
                <el-tooltip
                  placement="top"
                  effect="light"
                  :open-delay="500"
                  popper-class="custom-tooltip"
                >
                  <div slot="content">
                    <b>Unexplained reads</b><br>
                    Reads that could not be assigned to the expected RNA categories used by Picard.<br><br>
                    In simple terms: mapped reads that do not clearly fit into the usual coding, UTR, intronic, intergenic, ribosomal, or strand categories.<br><br>
                    <b>Expected values:</b> lower is better. High values may suggest annotation mismatch, unusual library composition, or technical artifacts.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">Unexplained reads</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                {{ scope.row.unexplained_reads.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>
          </el-table>
        </card>
      </div>

      <el-divider></el-divider>
    </div>


    <div v-if="Object.keys(qc_picard_rna).length !== 0" class="row">
      <div class="col-md-12">
        <div class="qc-section-title text-center">RNA genomic distribution</div>
      </div>

      <div class="col-md-12 mr-auto ml-auto">
        <card>
          <el-table
            :data="[qc_picard_rna]"
            border
            :header-cell-style="tableHeaderStyle"
            style="width: 100%"
          >
            <el-table-column
              prop="coding_bases"
              min-width="140"
              align="center"
            >
              <template #header>
                <el-tooltip placement="top" effect="light" :open-delay="500" popper-class="custom-tooltip">
                  <div slot="content">
                    <b>Coding bases</b><br>
                    Number of bases aligned to protein-coding parts of genes.<br><br>
                    In simple terms: how much sequencing signal comes from regions that directly encode proteins.<br><br>
                    <b>Expected values:</b> higher is generally better for clinical RNA analysis.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">Coding bases</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                <span v-if="scope.row.coding_bases !== null && scope.row.coding_bases !== undefined">
                  {{ scope.row.coding_bases.toLocaleString('cs-CZ') }}
                </span>
              </template>
            </el-table-column>

            <el-table-column
              prop="utr_bases"
              min-width="130"
              align="center"
            >
              <template #header>
                <el-tooltip placement="top" effect="light" :open-delay="500" popper-class="custom-tooltip">
                  <div slot="content">
                    <b>UTR bases</b><br>
                    Number of bases aligned to untranslated regions of genes.<br><br>
                    In simple terms: signal from gene regions that are part of transcripts but do not directly encode protein.<br><br>
                    <b>Expected values:</b> moderate values are expected in RNA-seq. Interpretation depends on assay design.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">UTR bases</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                <span v-if="scope.row.utr_bases !== null && scope.row.utr_bases !== undefined">
                  {{ scope.row.utr_bases.toLocaleString('cs-CZ') }}
                </span>
              </template>
            </el-table-column>

            <el-table-column
              prop="utr_bases_pct"
              min-width="110"
              align="center"
            >
              <template #header>
                <el-tooltip placement="top" effect="light" :open-delay="500" popper-class="custom-tooltip">
                  <div slot="content">
                    <b>UTR percentage</b><br>
                    Percentage of aligned RNA bases located in untranslated regions.<br><br>
                    In simple terms: the fraction of RNA signal coming from transcript regions that do not directly encode proteins.<br><br>
                    <b>Expected values:</b> assay-dependent. Review together with coding, intronic, and intergenic fractions.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">UTR %</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                <span v-if="scope.row.utr_bases_pct !== null && scope.row.utr_bases_pct !== undefined">
                  {{ scope.row.utr_bases_pct.toLocaleString('cs-CZ') }}
                </span>
              </template>
            </el-table-column>

            <el-table-column
              prop="intronic_bases"
              min-width="140"
              align="center"
            >
              <template #header>
                <el-tooltip placement="top" effect="light" :open-delay="500" popper-class="custom-tooltip">
                  <div slot="content">
                    <b>Intronic bases</b><br>
                    Number of bases aligned to intronic regions of genes.<br><br>
                    In simple terms: signal from gene regions that are usually removed during RNA processing.<br><br>
                    <b>Expected values:</b> lower is often preferable, but some intronic signal can be expected depending on RNA quality and library preparation.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">Intronic bases</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                <span v-if="scope.row.intronic_bases !== null && scope.row.intronic_bases !== undefined">
                  {{ scope.row.intronic_bases.toLocaleString('cs-CZ') }}
                </span>
              </template>
            </el-table-column>

            <el-table-column
              prop="intronic_bases_pct"
              min-width="120"
              align="center"
            >
              <template #header>
                <el-tooltip placement="top" effect="light" :open-delay="500" popper-class="custom-tooltip">
                  <div slot="content">
                    <b>Intronic percentage</b><br>
                    Percentage of aligned RNA bases located in intronic regions.<br><br>
                    In simple terms: how much of the RNA signal comes from introns rather than mature coding transcripts.<br><br>
                    <b>Expected values:</b> usually lower is better. Increased values may reflect pre-mRNA, DNA contamination, degraded RNA, or assay-specific behavior.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">Intronic %</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                <span v-if="scope.row.intronic_bases_pct !== null && scope.row.intronic_bases_pct !== undefined">
                  {{ scope.row.intronic_bases_pct.toLocaleString('cs-CZ') }}
                </span>
              </template>
            </el-table-column>

            <el-table-column
              prop="intergenic_bases"
              min-width="150"
              align="center"
            >
              <template #header>
                <el-tooltip placement="top" effect="light" :open-delay="500" popper-class="custom-tooltip">
                  <div slot="content">
                    <b>Intergenic bases</b><br>
                    Number of bases aligned outside annotated genes.<br><br>
                    In simple terms: signal that does not clearly come from known gene regions.<br><br>
                    <b>Expected values:</b> lower is better. High values may suggest contamination, annotation mismatch, or less specific RNA signal.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">Intergenic bases</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                <span v-if="scope.row.intergenic_bases !== null && scope.row.intergenic_bases !== undefined">
                  {{ scope.row.intergenic_bases.toLocaleString('cs-CZ') }}
                </span>
              </template>
            </el-table-column>

            <el-table-column
              prop="intergenic_bases_pct"
              min-width="130"
              align="center"
            >
              <template #header>
                <el-tooltip placement="top" effect="light" :open-delay="500" popper-class="custom-tooltip">
                  <div slot="content">
                    <b>Intergenic percentage</b><br>
                    Percentage of aligned RNA bases located outside annotated genes.<br><br>
                    In simple terms: the fraction of RNA signal that does not map to known gene regions.<br><br>
                    <b>Expected values:</b> lower is better. High values may indicate less informative sequencing signal.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">Intergenic %</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                <span v-if="scope.row.intergenic_bases_pct !== null && scope.row.intergenic_bases_pct !== undefined">
                  {{ scope.row.intergenic_bases_pct.toLocaleString('cs-CZ') }}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </card>
      </div>

      <el-divider></el-divider>
    </div>


    <div v-if="Object.keys(qc_picard_rna).length !== 0" class="row">
      <div class="col-md-12">
        <div class="qc-section-title text-center">Strand specificity and transcript bias</div>
      </div>

      <div class="col-md-12 mr-auto ml-auto">
        <card>
          <el-table
            :data="[qc_picard_rna]"
            border
            :header-cell-style="tableHeaderStyle"
            style="width: 100%"
          >
            <el-table-column
              prop="correct_strand_reads_pct"
              min-width="150"
              align="center"
            >
              <template #header>
                <el-tooltip placement="top" effect="light" :open-delay="500" popper-class="custom-tooltip">
                  <div slot="content">
                    <b>Correct strand reads</b><br>
                    Percentage of aligned reads assigned to the expected transcript strand.<br><br>
                    In simple terms: whether the RNA library keeps the expected direction of transcription.<br><br>
                    <b>Expected values:</b> high values are expected for strand-specific libraries. Values close to 100 are very good.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">Correct strand %</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                {{ scope.row.correct_strand_reads_pct.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="incorrect_strand_reads"
              min-width="160"
              align="center"
            >
              <template #header>
                <el-tooltip placement="top" effect="light" :open-delay="500" popper-class="custom-tooltip">
                  <div slot="content">
                    <b>Incorrect strand reads</b><br>
                    Number of aligned reads assigned to the opposite strand from the expected transcript direction.<br><br>
                    In simple terms: reads pointing in the wrong direction for a strand-specific RNA library.<br><br>
                    <b>Expected values:</b> lower is better. High values may indicate wrong strand configuration or library preparation issues.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">Wrong strand reads</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                {{ scope.row.incorrect_strand_reads.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="r1_transcript_strand_pct"
              min-width="130"
              align="center"
            >
              <template #header>
                <el-tooltip placement="top" effect="light" :open-delay="500" popper-class="custom-tooltip">
                  <div slot="content">
                    <b>R1 transcript strand</b><br>
                    Percentage of reads supporting the model where read 1 follows the transcript strand.<br><br>
                    In simple terms: helps confirm which read direction represents the RNA transcript.<br><br>
                    <b>Expected values:</b> for a strongly stranded library, either R1 or R2 should dominate depending on the library protocol.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">R1 strand %</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                {{ scope.row.r1_transcript_strand_pct.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="r2_transcript_strand_pct"
              min-width="130"
              align="center"
            >
              <template #header>
                <el-tooltip placement="top" effect="light" :open-delay="500" popper-class="custom-tooltip">
                  <div slot="content">
                    <b>R2 transcript strand</b><br>
                    Percentage of reads supporting the model where read 2 follows the transcript strand.<br><br>
                    In simple terms: helps confirm whether the second read represents the RNA transcript direction.<br><br>
                    <b>Expected values:</b> for a strongly stranded library, either R1 or R2 should dominate depending on the library protocol.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">R2 strand %</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                {{ scope.row.r2_transcript_strand_pct.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="median_5prime_bias"
              min-width="130"
              align="center"
            >
              <template #header>
                <el-tooltip placement="top" effect="light" :open-delay="500" popper-class="custom-tooltip">
                  <div slot="content">
                    <b>5′ bias</b><br>
                    Median bias toward the 5′ end of transcripts.<br><br>
                    In simple terms: shows whether coverage is unusually concentrated at the beginning of transcripts.<br><br>
                    <b>Expected values:</b> close to 0 is best. Higher values indicate stronger 5′ bias.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">5′ bias</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                {{ scope.row.median_5prime_bias.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="median_3prime_bias"
              min-width="130"
              align="center"
            >
              <template #header>
                <el-tooltip placement="top" effect="light" :open-delay="500" popper-class="custom-tooltip">
                  <div slot="content">
                    <b>3′ bias</b><br>
                    Median bias toward the 3′ end of transcripts.<br><br>
                    In simple terms: shows whether coverage is unusually concentrated at the end of transcripts.<br><br>
                    <b>Expected values:</b> close to 0 is best. Higher values indicate stronger 3′ bias, often seen with degraded RNA or protocol-specific effects.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">3′ bias</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                {{ scope.row.median_3prime_bias.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>

            <el-table-column
              prop="median_5prime_to_3prime_bias"
              min-width="150"
              align="center"
            >
              <template #header>
                <el-tooltip placement="top" effect="light" :open-delay="500" popper-class="custom-tooltip">
                  <div slot="content">
                    <b>5′/3′ bias</b><br>
                    Ratio-like summary comparing coverage toward the 5′ and 3′ ends of transcripts.<br><br>
                    In simple terms: shows whether transcripts are covered evenly from beginning to end.<br><br>
                    <b>Expected values:</b> closer to 1 is usually more balanced. Strong deviation suggests uneven transcript coverage.
                  </div>
                  <span style="cursor: help; text-decoration: underline;">5′/3′ bias</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                {{ scope.row.median_5prime_to_3prime_bias.toLocaleString('cs-CZ') }}
              </template>
            </el-table-column>
          </el-table>
        </card>
      </div>

      <el-divider></el-divider>
    </div>

  </div>
</template>
<script>
  import moment from 'moment';
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
  import axios from 'axios';

  import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue';
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard';
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard';
  import LineChart from 'src/components/UIComponents/Charts/LineChart';
  import BarChart from 'src/components/UIComponents/Charts/BarChart';
  import PieChart from 'src/components/UIComponents/Charts/PieChart';
  import {Badge, Card} from 'src/components/UIComponents';
  import TaskList from './Dashboard/Widgets/TaskList';

  import {Table, TableColumn, Divider } from 'element-ui';


  const tooltipOptions = {
    tooltipFillColor: "rgba(0,0,0,0.5)",
    tooltipFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
    tooltipFontSize: 14,
    tooltipFontStyle: "normal",
    tooltipFontColor: "#fff",
    tooltipTitleFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
    tooltipTitleFontSize: 14,
    tooltipTitleFontStyle: "bold",
    tooltipTitleFontColor: "#fff",
    tooltipYPadding: 6,
    tooltipXPadding: 6,
    tooltipCaretSize: 8,
    tooltipCornerRadius: 6,
    tooltipXOffset: 10,
  };

  export default {
    name: 'exam_qc',
    props: {
      got_id_examination: {
        type: String,
        default: '0',
        description: ''
      },
    },
    components: {
      StatsCard,
      CircleChartCard,
      Badge,
      TaskList,
      Card,
      ChartCard,
      LineChart,
      BarChart,
      PieChart,
      Table,
      TableColumn,
      Divider,
    },

    computed: {
      ...mapState({
        token: state => state.token,
        qc_picard_hs: state => state.qc_picard_hs,
        qc_picard_rna: state => state.qc_picard_rna,
        qc_picard_amp: state => state.qc_picard_amp,
        qc_picard_amp_target: state => state.qc_picard_amp_target,
        id_examination: state => state.id_examination,
        chart_bar_a: state => state.chart_bar_a,
      }),
    },


    data () {
      return {
        mydata: [
          33,
          22,
        ],
        aa: 11,
        bb: 88,


        chart_test: [
          { name: 'Page A', pv: 2000 },
          { name: 'Page B', pv: 3000 },
          { name: 'Page C', pv: 1200 }
        ],

        chart_on_target: [
          { name: 'Page A', pv: 2000 },
          { name: 'Page B', pv: 3000 },
          { name: 'Page C', pv: 1200 }
        ],


        activeUsersChart: {
          data: {
            labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct"],
            series: [542, 480, 430, 550, 530, 453, 380, 434, 568, 610]
          }
        },

        // emailsCampaignChart: {
        //   data: {
        //     labels: ["12pm", "3pm", "6pm", "9pm", "12am", "3am", "6am", "9am"],
        //     series: [40, 500, 650, 700, 1200, 1250, 1300, 1900]
        //   }
        // },

        // activeCountriesChart: {
        //   data: {
        //     labels: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October"],
        //     series: [80, 78, 86, 96, 83, 85, 76, 75, 88, 90]
        //   }
        // },

        // activityChart: {
        //   labels: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
        //   datasets: [
        //     {
        //       label: "Data",
        //       borderColor: '#fcc468',
        //       fill: true,
        //       backgroundColor: '#fcc468',
        //       hoverBorderColor: '#fcc468',
        //       borderWidth: 8,
        //       data: [100, 120, 80, 100, 90, 130, 110, 100, 80, 110, 130, 140, 130, 120, 130, 80, 100, 90, 120, 130],
        //     },
        //     {
        //       label: "Data",
        //       borderColor: '#4cbdd7',
        //       fill: true,
        //       backgroundColor: '#4cbdd7',
        //       hoverBorderColor: '#4cbdd7',
        //       borderWidth: 8,
        //       data: [80, 140, 50, 120, 50, 150, 60, 130, 50, 130, 150, 100, 110, 80, 140, 50, 140, 50, 110, 150],
        //     }
        //   ],
        //   options: {
        //     tooltips: tooltipOptions
        //   }
        // },

        // stockChart: {
        //   labels: ["6pm", "9pm", "11pm", "2am", "4am", "6am", "8am"],
        //   datasets: [{
        //     label: "Active Users",
        //     borderColor: "#f17e5d",
        //     pointBackgroundColor: "#f17e5d",
        //     pointRadius: 3,
        //     pointHoverRadius: 3,
        //     lineTension: 0,
        //     fill: false,
        //     borderWidth: 3,
        //     data: [200, 250, 300, 350, 280, 330, 400]
        //   }],
        //   color: '#f17e5d',
        //   options: {
        //     tooltips: tooltipOptions,
        //     scales: {
        //       yAxes: [{

        //         ticks: {
        //           fontColor: "#9f9f9f",
        //           beginAtZero: false,
        //           maxTicksLimit: 3,
        //         },
        //         gridLines: {
        //           drawBorder: false,
        //           borderDash: [8, 5],
        //           zeroLineColor: "transparent",
        //           color: '#9f9f9f'
        //         }

        //       }],

        //       xAxes: [{
        //         barPercentage: 1.6,
        //         gridLines: {
        //           drawBorder: false,
        //           borderDash: [8, 5],
        //           color: '#9f9f9f',
        //           zeroLineColor: "transparent"
        //         },
        //         ticks: {
        //           padding: 20,
        //           fontColor: "#9f9f9f"
        //         }
        //       }]
        //     }
        //   }
        // },

        // viewsChart: {
        //   labels: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
        //   datasets: [
        //     {
        //       label: "Data",
        //       borderColor: '#fcc468',
        //       fill: true,
        //       backgroundColor: '#fcc468',
        //       hoverBorderColor: '#fcc468',
        //       borderWidth: 5,
        //       data: [100, 120, 80, 100, 90, 130, 110, 100, 80, 110, 130, 140, 130, 120, 130, 80, 100, 90, 120, 130],
        //     }
        //   ]
        // },


        // bioxsysChart: {
        //   labels: [1, 2],
        //   datasets: [{
        //     label: "Bioxsys",
        //     pointRadius: 0,
        //     pointHoverRadius: 0,
        //     backgroundColor: [
        //       'cyan',
        //       'yellow',
        //     ],
        //     borderWidth: 0,
        //     data: [this.qc_a["pct_selected_bases"], this.qc_a["pct_off_bait"]]
        //   }],
        //   options: {
        //     tooltips: tooltipOptions
        //   }
        // },

        // concurrentChart: {
        //   labels: [1, 2],
        //   datasets: [{
        //     label: "Concurrent",
        //     pointRadius: 0,
        //     pointHoverRadius: 0,
        //     backgroundColor: [
        //       'green',
        //       'red',
        //     ],
        //     borderWidth: 0,
        //     data: [20, 80]
        //   }],
        //   options: {
        //     tooltips: tooltipOptions
        //   }
        // },

        // emailChart: {
        //   labels: [1, 2, 3],
        //   datasets: [{
        //     label: "Emails",
        //     pointRadius: 0,
        //     pointHoverRadius: 0,
        //     backgroundColor: [
        //       '#e3e3e3',
        //       '#4acccd',
        //       '#fcc468'
        //     ],
        //     borderWidth: 0,
        //     data: [542, 480, 430]
        //   }],
        //   options: {
        //     tooltips: tooltipOptions
        //   }
        // },

        // chartHours: {
        //   data: {

        //     labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct"],
        //     datasets: [{
        //       borderColor: "#6bd098",
        //       backgroundColor: "#6bd098",
        //       pointRadius: 0,
        //       pointHoverRadius: 0,
        //       borderWidth: 3,
        //       data: [300, 310, 316, 322, 330, 326, 333, 345, 338, 354]
        //     },
        //       {
        //         borderColor: "#f17e5d",
        //         backgroundColor: "#f17e5d",
        //         pointRadius: 0,
        //         pointHoverRadius: 0,
        //         borderWidth: 3,
        //         data: [320, 340, 365, 360, 370, 385, 390, 384, 408, 420]
        //       },
        //       {
        //         borderColor: "#fcc468",
        //         backgroundColor: "#fcc468",
        //         pointRadius: 0,
        //         pointHoverRadius: 0,
        //         borderWidth: 3,
        //         data: [370, 394, 415, 409, 425, 445, 460, 450, 478, 484]
        //       }
        //     ]
        //   },
        //   options: {
        //     tooltips: tooltipOptions,
        //     scales: {
        //       yAxes: [{

        //         ticks: {
        //           fontColor: "#9f9f9f",
        //           beginAtZero: false,
        //           maxTicksLimit: 5,
        //           //padding: 20
        //         },
        //         gridLines: {
        //           drawBorder: false,
        //           zeroLineColor: "transparent",
        //           color: 'rgba(255,255,255,0.05)'
        //         }

        //       }],

        //       xAxes: [{
        //         barPercentage: 1.6,
        //         gridLines: {
        //           drawBorder: false,
        //           color: 'rgba(255,255,255,0.1)',
        //           zeroLineColor: "transparent",
        //           display: false,
        //         },
        //         ticks: {
        //           padding: 20,
        //           fontColor: "#9f9f9f"
        //         }
        //       }]
        //     }
        //   }
        // },


        // tableData: [{
        //   date: '2016-05-03',
        //   name: 'Tom',
        //   address: 'No. 189, Grove St, Los Angeles'
        // }, {
        //   date: '2016-05-02',
        //   name: 'Tom',
        //   address: 'No. 189, Grove St, Los Angeles'
        // }, {
        //   date: '2016-05-04',
        //   name: 'Tom',
        //   address: 'No. 189, Grove St, Los Angeles'
        // }, {
        //   date: '2016-05-01',
        //   name: 'Tom',
        //   address: 'No. 189, Grove St, Los Angeles'
        // }],

      }

    },


    methods: {
      tableHeaderStyle ({row, column, rowIndex, columnIndex}) {
        return 'color:#000;font-weight:800;'
      },


      getRandomInt () {
        return Math.floor(Math.random() * (50 - 5 + 1)) + 5
      },


      qc_picard_amp_target_summary (param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = 'Sum';
            return;
          } else if (index === 5) {
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
              sums[index] = sums[index].toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
            } else {
              sums[index] = '';
            }
          } else {
            sums[index] = '';
          }

        });

        return sums;
      }




    },






  }

</script>
<style scoped>
  .bottom_margin_10 {
    margin-bottom: 10px;
  }

  .top_padd {
    padding-top: 90px !important;
  }

.el-table {
    color: black !important;
}


el-table>.thead {
    color: red !important;
}

.qc-section-title {
  font-size: 18px;
  font-weight: 500;
  color: #606266;
  margin-top: 18px;
  margin-bottom: 18px;
  letter-spacing: 0.2px;
}

</style>
